import {
  DTOInterestTutorialCategory,
  DTOInterestTutorialItem,
  DTOInterestTutorialResponse,
} from 'src/apis/dto/DTOInterestTutorial';

export interface CategorizedInterests {
  category: DTOInterestTutorialCategory;
  interests: DTOInterestTutorialItem[];
}

/**
 * interests와 categories를 카테고리별로 그룹핑.
 * categories 배열 순서대로 정렬되며, 관심사가 0개인 카테고리는 제외.
 */
export const groupInterestsByCategory = (
  data: DTOInterestTutorialResponse
): CategorizedInterests[] => {
  const { interests, categories } = data;

  return categories
    .map((category) => ({
      category,
      interests: interests.filter((interest) => interest.categoryId === category.id),
    }))
    .filter(({ interests: items }) => items.length > 0);
};
